import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {Countries, PhoneRegex} from '../../../constants/general-variables';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationHelperService} from '../../../services/helpers/authentication-helper.service';
import {ToastrService} from 'ngx-toastr';
import {DatePipe} from '@angular/common';
import {ProfileHttpService} from '../../../services/http-services/profile/profile-http.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import {Subject} from "rxjs";

@Component({
  selector: 'tl-add-account-details',
  templateUrl: './add-account-details.component.html',
  providers: [DatePipe]
})
export class AddAccountDetailsComponent implements OnInit, OnDestroy {
  completeRegistrationForm!: FormGroup;
  isSpinnerActive = false;
  isAreaCodeOpen =  false;
  selectedCountry: any = null;
  showCountryDropdown = false;
  searchQuery = '';
  selectedArea = Countries[0];
  filteredCountries = Countries;
  formTriedToSubmit = false;
  showPhoneField = false;
  taken = false;
  available = [];
  @ViewChild('areaCodeBtn') areaCodeBtn: ElementRef | undefined;
  @ViewChild('countrySearch') countrySearch: ElementRef | undefined;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  protected readonly Countries = Countries;
  private readonly debounceTimeMs = 500;
  private searchSubject = new Subject<string>();

  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private toastService: ToastrService,
              private activatedRoute: ActivatedRoute,
              private authHelperService: AuthenticationHelperService,
              private profileHttpService: ProfileHttpService) { }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.url.map(segment => segment.path).join('/') === PAGES_AND_PATHS.completeRegistrationSocial.pageInRouting) {
      this.showPhoneField = true;
    }

    this.buildForm();

    this.searchSubject.pipe(debounceTime(this.debounceTimeMs)).subscribe((searchValue) => {
      this.onUsernameChange(searchValue);
    });
  }

  ngOnDestroy(): void {
    this.searchSubject.complete();
  }

  onSearch(): void {
    if (this.completeRegistrationForm.controls.username.value) {
      this.searchSubject.next(this.completeRegistrationForm.controls.username.value);
    }
  }

  buildForm(): void {
    this.completeRegistrationForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      country: ['', [Validators.required]],
    });

    if (this.showPhoneField) {
      this.completeRegistrationForm.addControl(
        'phone_number',
        this.formBuilder.control('', [Validators.required, Validators.pattern(PhoneRegex)])
      );

      this.completeRegistrationForm.addControl(
        'tos',
        this.formBuilder.control(false, [Validators.requiredTrue])
      );
    }
  }

  onSearchCountries(): void {
    this.filteredCountries = Countries.filter(country => {
      return country.name.toLowerCase().includes(this.searchQuery.toLowerCase());
    });
  }

  onBlurSearchbar(): void {
    setTimeout(() => {
      this.showCountryDropdown = false;
    }, 200);
    this.completeRegistrationForm.controls.country.markAsTouched();
  }

  onSelectCountry(country: any): void {
    this.completeRegistrationForm.controls.country.patchValue(country.name);
    this.selectedCountry = country;
    this.searchQuery = country.name;
  }

  removeSelectedCountry(): void {
    this.selectedCountry = null;
    this.completeRegistrationForm.controls.country.patchValue('');
    this.onSearchCountries();
    setTimeout(() => {
      this.countrySearch?.nativeElement.focus();
    }, 200);
  }

  onSubmitCompleteRegistrationForm(): void {
    this.formTriedToSubmit = true;
    if (this.completeRegistrationForm.valid) {
      this.isSpinnerActive = true;

      let formData = {};

      if (this.showPhoneField) {
        formData = {
          ...this.completeRegistrationForm.value,
          phone_number: this.selectedArea.phone_code + ' ' + this.completeRegistrationForm.controls.phone_number.value
        };
      } else {
        formData = {
          ...this.completeRegistrationForm.value
        };
      }

      this.profileHttpService.editAuthUserProfile(formData)
        .then(res => {
          this.isSpinnerActive = false;
          const userdata = this.authHelperService.getUserData;

          userdata.username = this.completeRegistrationForm.controls.username.value;
          userdata.country = this.completeRegistrationForm.controls.country.value;

          if (this.showPhoneField) {
            userdata.phone_number = this.selectedArea.phone_code + ' ' + this.completeRegistrationForm.controls.phone_number.value;
          }

          this.authHelperService.setUserData(userdata);
          if (this.showPhoneField) {
            this.router.navigate([PAGES_AND_PATHS.verifyAccount.pagePath], {
              state: { navigateTopics: true },
            });
          } else {
            this.router.navigate([PAGES_AND_PATHS.selectTopics.pagePath]);
          }

        }).catch(({error}: {error: { errors: { [key: string]: string }}}) => {
          this.isSpinnerActive = false;
          Object.values(error.errors).forEach(error => this.toastService.error());
        });
    }
  }

  onUsernameChange(value: string): void {
      this.profileHttpService
        .checkUsername(value)
        .then((r: any) => {
          this.taken = r.exists;
          this.available = r.available;
        });
  }

  onSelectCodeArea(country: any): void {
    this.selectedArea = country;
    this.isAreaCodeOpen = false;
  }
}
